import { tableActionsCreator } from "app/actions/tableActions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import type { AnyAction } from "redux";
import { WEBSITES_RESULTS_TABLE_KEY } from "../sub-modules/company-search/constants/websites-table";

const useClearAndCloseRowsSelection = (
    tableRowsSelectionToggledAction: (isRowSelectionEnabled: boolean) => AnyAction,
    tableKey?: string,
    tableProperty?: string,
): VoidFunction => {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            clearAndCloseRowsSelection();
        };
    }, []);

    const clearAndCloseRowsSelection = () => {
        dispatch(tableRowsSelectionToggledAction(false));
        dispatch(
            tableActionsCreator(tableKey ?? WEBSITES_RESULTS_TABLE_KEY, tableProperty ?? "site").clearAllSelectedRows(),
        );
    };

    return clearAndCloseRowsSelection;
};

export default useClearAndCloseRowsSelection;
